import * as ambassadorWixRestaurantsV1OperationGroup from './restaurants-v1-operation-group-operation-groups.http.js';
import * as ambassadorWixRestaurantsV1OperationGroupTypes from './restaurants-v1-operation-group-operation-groups.types.js';
import * as ambassadorWixRestaurantsV1OperationGroupUniversalTypes from './restaurants-v1-operation-group-operation-groups.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createOperationGroup(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsV1OperationGroupUniversalTypes.CreateOperationGroupRequest,
  ambassadorWixRestaurantsV1OperationGroupTypes.CreateOperationGroupRequest,
  ambassadorWixRestaurantsV1OperationGroupUniversalTypes.CreateOperationGroupResponse,
  ambassadorWixRestaurantsV1OperationGroupTypes.CreateOperationGroupResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsV1OperationGroup.createOperationGroup(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/operation-groups',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getOperationGroup(): __PublicMethodMetaInfo<
  'GET',
  { operationGroupId: string },
  ambassadorWixRestaurantsV1OperationGroupUniversalTypes.GetOperationGroupRequest,
  ambassadorWixRestaurantsV1OperationGroupTypes.GetOperationGroupRequest,
  ambassadorWixRestaurantsV1OperationGroupUniversalTypes.GetOperationGroupResponse,
  ambassadorWixRestaurantsV1OperationGroupTypes.GetOperationGroupResponse
> {
  const payload = { operationGroupId: ':operationGroupId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsV1OperationGroup.getOperationGroup(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/operation-groups/{operationGroupId}',
    pathParams: { operationGroupId: 'operationGroupId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateOperationGroup(): __PublicMethodMetaInfo<
  'PATCH',
  { operationGroupId: string },
  ambassadorWixRestaurantsV1OperationGroupUniversalTypes.UpdateOperationGroupRequest,
  ambassadorWixRestaurantsV1OperationGroupTypes.UpdateOperationGroupRequest,
  ambassadorWixRestaurantsV1OperationGroupUniversalTypes.UpdateOperationGroupResponse,
  ambassadorWixRestaurantsV1OperationGroupTypes.UpdateOperationGroupResponse
> {
  const payload = { operationGroup: { id: ':operationGroupId' } } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsV1OperationGroup.updateOperationGroup(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/operation-groups/{operationGroup.id}',
    pathParams: { operationGroupId: 'operationGroupId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteOperationGroup(): __PublicMethodMetaInfo<
  'DELETE',
  { operationGroupId: string },
  ambassadorWixRestaurantsV1OperationGroupUniversalTypes.DeleteOperationGroupRequest,
  ambassadorWixRestaurantsV1OperationGroupTypes.DeleteOperationGroupRequest,
  ambassadorWixRestaurantsV1OperationGroupUniversalTypes.DeleteOperationGroupResponse,
  ambassadorWixRestaurantsV1OperationGroupTypes.DeleteOperationGroupResponse
> {
  const payload = { operationGroupId: ':operationGroupId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsV1OperationGroup.deleteOperationGroup(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/operation-groups/{operationGroupId}',
    pathParams: { operationGroupId: 'operationGroupId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryOperationGroups(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixRestaurantsV1OperationGroupUniversalTypes.QueryOperationGroupsRequest,
  ambassadorWixRestaurantsV1OperationGroupTypes.QueryOperationGroupsRequest,
  ambassadorWixRestaurantsV1OperationGroupUniversalTypes.QueryOperationGroupsResponse,
  ambassadorWixRestaurantsV1OperationGroupTypes.QueryOperationGroupsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsV1OperationGroup.queryOperationGroups(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/operation-groups/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkCreateOperationGroups(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsV1OperationGroupUniversalTypes.BulkCreateOperationGroupsRequest,
  ambassadorWixRestaurantsV1OperationGroupTypes.BulkCreateOperationGroupsRequest,
  ambassadorWixRestaurantsV1OperationGroupUniversalTypes.BulkCreateOperationGroupsResponse,
  ambassadorWixRestaurantsV1OperationGroupTypes.BulkCreateOperationGroupsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsV1OperationGroup.bulkCreateOperationGroups(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/operation-groups/create',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateOperationGroups(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsV1OperationGroupUniversalTypes.BulkUpdateOperationGroupsRequest,
  ambassadorWixRestaurantsV1OperationGroupTypes.BulkUpdateOperationGroupsRequest,
  ambassadorWixRestaurantsV1OperationGroupUniversalTypes.BulkUpdateOperationGroupsResponse,
  ambassadorWixRestaurantsV1OperationGroupTypes.BulkUpdateOperationGroupsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsV1OperationGroup.bulkUpdateOperationGroups(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/operation-groups/update',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkDeleteOperationGroups(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsV1OperationGroupUniversalTypes.BulkDeleteOperationGroupsRequest,
  ambassadorWixRestaurantsV1OperationGroupTypes.BulkDeleteOperationGroupsRequest,
  ambassadorWixRestaurantsV1OperationGroupUniversalTypes.BulkDeleteOperationGroupsResponse,
  ambassadorWixRestaurantsV1OperationGroupTypes.BulkDeleteOperationGroupsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsV1OperationGroup.bulkDeleteOperationGroups(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/operation-groups/delete',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateOperationGroupTags(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsV1OperationGroupUniversalTypes.BulkUpdateOperationGroupTagsRequest,
  ambassadorWixRestaurantsV1OperationGroupTypes.BulkUpdateOperationGroupTagsRequest,
  ambassadorWixRestaurantsV1OperationGroupUniversalTypes.BulkUpdateOperationGroupTagsResponse,
  ambassadorWixRestaurantsV1OperationGroupTypes.BulkUpdateOperationGroupTagsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsV1OperationGroup.bulkUpdateOperationGroupTags(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/operation-groups/update-tags',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateOperationGroupTagsByFilter(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsV1OperationGroupUniversalTypes.BulkUpdateOperationGroupTagsByFilterRequest,
  ambassadorWixRestaurantsV1OperationGroupTypes.BulkUpdateOperationGroupTagsByFilterRequest,
  ambassadorWixRestaurantsV1OperationGroupUniversalTypes.BulkUpdateOperationGroupTagsByFilterResponse,
  ambassadorWixRestaurantsV1OperationGroupTypes.BulkUpdateOperationGroupTagsByFilterResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsV1OperationGroup.bulkUpdateOperationGroupTagsByFilter(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/operation-groups/update-tags-by-filter',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  OperationGroup as OperationGroupOriginal,
  Image as ImageOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  Tags as TagsOriginal,
  TagList as TagListOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  CreateOperationGroupRequest as CreateOperationGroupRequestOriginal,
  CreateOperationGroupResponse as CreateOperationGroupResponseOriginal,
  GetOperationGroupRequest as GetOperationGroupRequestOriginal,
  GetOperationGroupResponse as GetOperationGroupResponseOriginal,
  UpdateOperationGroupRequest as UpdateOperationGroupRequestOriginal,
  UpdateOperationGroupResponse as UpdateOperationGroupResponseOriginal,
  DeleteOperationGroupRequest as DeleteOperationGroupRequestOriginal,
  DeleteOperationGroupResponse as DeleteOperationGroupResponseOriginal,
  QueryOperationGroupsRequest as QueryOperationGroupsRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryOperationGroupsResponse as QueryOperationGroupsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  BulkCreateOperationGroupsRequest as BulkCreateOperationGroupsRequestOriginal,
  BulkCreateOperationGroupsResponse as BulkCreateOperationGroupsResponseOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkOperationGroupResult as BulkOperationGroupResultOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  BulkUpdateOperationGroupsRequest as BulkUpdateOperationGroupsRequestOriginal,
  MaskedOperationGroup as MaskedOperationGroupOriginal,
  BulkUpdateOperationGroupsResponse as BulkUpdateOperationGroupsResponseOriginal,
  BulkUpdateOperationGroupsResponseBulkOperationGroupResult as BulkUpdateOperationGroupsResponseBulkOperationGroupResultOriginal,
  BulkDeleteOperationGroupsRequest as BulkDeleteOperationGroupsRequestOriginal,
  BulkDeleteOperationGroupsResponse as BulkDeleteOperationGroupsResponseOriginal,
  BulkDeleteOperationGroupsResponseBulkOperationGroupResult as BulkDeleteOperationGroupsResponseBulkOperationGroupResultOriginal,
  BulkUpdateOperationGroupTagsRequest as BulkUpdateOperationGroupTagsRequestOriginal,
  BulkUpdateOperationGroupTagsResponse as BulkUpdateOperationGroupTagsResponseOriginal,
  BulkUpdateOperationGroupTagsResult as BulkUpdateOperationGroupTagsResultOriginal,
  BulkUpdateOperationGroupTagsByFilterRequest as BulkUpdateOperationGroupTagsByFilterRequestOriginal,
  BulkUpdateOperationGroupTagsByFilterResponse as BulkUpdateOperationGroupTagsByFilterResponseOriginal,
  BulkUpdateOperationGroupTagsApplicationErrors as BulkUpdateOperationGroupTagsApplicationErrorsOriginal,
  BulkUpdateOperationGroupTagsByFilterApplicationErrors as BulkUpdateOperationGroupTagsByFilterApplicationErrorsOriginal,
} from './restaurants-v1-operation-group-operation-groups.types.js';
